import GroceryOrdersListPanel from '../../components/grocery/GroceryOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function MerchantGroceryOrderHistoryPage() {
  return (
    <PageShell>
      <PageHeader
        title="Grocery Order History"
        subtitle="Delivered, cancelled, and past store orders"
      />
      <GroceryOrdersListPanel
        scope="history"
        title="Past grocery orders"
        queryKeyPrefix="merchant-grocery-history"
      />
    </PageShell>
  );
}
